import React from "react";
import Image from "next/image";
import { Link } from "../../../navigation";
import { toCockpitImagePath } from "../../cms/components/CockpitImage";

const NavigationItem = ({
  link,
  title,
  image = null,
  imageSize = { width: 100, height: 30 }, // Default size
  subtitle = null,
  isLink = true,
  onClick = null,
  className = "",
}) => {
  const LinkComponent = isLink ? Link : "button";
  const pathname = isLink ? link?.route || link : undefined;
  if (isLink && !pathname) return null;
  return (
    <LinkComponent
      href={pathname}
      onClick={onClick}
      className={`${className} nav-hover`}
      aria-label={title}
    >
      {image?.path && (
        <Image
          src={toCockpitImagePath(image.path)}
          alt={title || "Image"}
          width={imageSize.width}
          height={imageSize.height}
          style={{
            objectFit: "cover",
            objectPosition: "center",
            ...(imageSize || {}),
          }}
          unoptimized={image?.path?.endsWith(".svg")}
        />
      )}

      <div className="mt-2-5">
        <div className="nav-title d-block mb-1">{title}</div>
        {subtitle && (
          <div className="public-nav-item line-clamp-4 bold">{subtitle}</div>
        )}
      </div>
    </LinkComponent>
  );
};

export default NavigationItem;
